/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import { ReduxStateLoadable } from '@reducers/types';
import { AnyAction } from 'redux';
import { PeerComparison } from '../types/initiative';

type State = ReduxStateLoadable<PeerComparison, Partial<PeerComparison>> & { initiativeId?: string }
const getDefaultState = (): State => ({
  data: {},
  loaded: false,
  errored: false,
  errorMessage: ''
});

const peerComparison = (
  state = getDefaultState(),
  action: AnyAction,
): State => {

  const lastUpdated = Date.now();
  switch (action.type) {
    case actionTypes.LOADING_PEER_COMPARISON:
      return {
        ...state,
        data: {},
        initiativeId: action.initiativeId,
        loaded: false,
        errored: false,
        lastUpdated
      };
    case actionTypes.ERROR_PEER_COMPARISON:
      return {
        ...state,
        data: {},
        loaded: false,
        errored: true,
        lastUpdated,
        initiativeId: undefined,
        errorMessage: action.errorMessage
      };
    case actionTypes.LOADED_PEER_COMPARISON:
      return {
        ...state,
        data: action.data,
        loaded: true,
        errored: false,
        lastUpdated
      };
    default:
      return state;
  }
};

export default peerComparison;
